// Discreet placeholder for malformed or unknown block types. Partners
// can ship new block types in additive v1 minor versions; older
// renderers that don't know the type render this stub instead of
// throwing. Per-block degradation, not whole-document failure.
export function UnsupportedBlock({ type }: { type: string }) {
  return (
    <div className="rounded-control border border-dashed border-border bg-app-panel2/40 px-3 py-2 text-xs text-app-subtle">
      [ unsupported block: {type} ]
    </div>
  )
}
